import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

const CardAction = ({ img, title, subtitle, description, nameButton, url }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.9)), url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        p: { xs: 2.5, md: 4 },
        borderRadius: 2.5,
        textAlign: "left",
        minHeight: { xs: 310, md: 360 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="h4"
        component="h3"
        sx={{ color: "#facc2e", mb: 1.5, fontSize: { xs: "1.45rem", md: "2.1rem" }, fontWeight: 700, lineHeight: 1.2 }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        sx={{ mb: 2, color: '#fff9', fontSize: { xs: "1rem", md: "1.2rem" } }}
      >
        {subtitle}
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: "4px",
          display: "inline-flex",
          backgroundColor: "#facc2e",
          mb: 2,
        }}
      />
      <Typography
        variant="body1"
        sx={{ mb: 3, color: "white", fontSize: { xs: "0.95rem", md: "1.05rem" }, lineHeight: 1.6 }}
      >
        {description}
      </Typography>
      <Button
        size="large"
        onClick={() => url && navigate(url)}
        sx={{
          backgroundColor: "#fec428",
          color: "#000",
          fontSize: { xs: "0.95rem", md: "1.05rem" },
          fontWeight: 700,
          alignSelf: "flex-start",
          "&:hover": { backgroundColor: "#e4b021" },
        }}
      >
        {nameButton}
      </Button>
    </Box>
  );
};

export default CardAction;
